
export default function BadgeDisplay({ latestBadges }) {

    return (
        <div className="mb-4 outline outline-1 outline-gray-300 pb-2 rounded-3xl">
          <div className="flex flex-col justify-center text-center">
            <p className="my-2 font-major text-lg">bAdGeS</p>
            <div className="flex flex-wrap gap-4 justify-center items-center">
              {latestBadges.length === 0 ? (
                <div className="w-1/2 text-center">
                  <img
                    src="/images/no_badge.png"
                    alt="No badges yet"
                    className="mx-auto h-auto mb-2 opacity-60"
                  />
                  <p className="mt-2 text-xs text-gray-500">ingen badges endnu – kom i gang 💪</p>
                </div>
              ) : (
                latestBadges.map((badge, index) => (
                  <div key={index} className="w-1/3 m-2 mt-4 text-center">
                    <img src={badge.image} alt={badge.label} className="mx-auto h-auto mb-2" />
                    <p className="text-xs font-semibold">{badge.label}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
    )
}